// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/UserConfigurationEntryReadPermission.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file Enumerations/UserConfigurationEntryReadPermission.proto.
 */
export const file_Enumerations_UserConfigurationEntryReadPermission: GenFile = /*@__PURE__*/
  fileDesc("CjdFbnVtZXJhdGlvbnMvVXNlckNvbmZpZ3VyYXRpb25FbnRyeVJlYWRQZXJtaXNzaW9uLnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyrrAQokVXNlckNvbmZpZ3VyYXRpb25FbnRyeVJlYWRQZXJtaXNzaW9uEj4KOlVTRVJfQ09ORklHVVJBVElPTl9FTlRSWV9SRUFEX1BFUk1JU1NJT05fUFJJVkFURV9TRUxGX09OTFkQABJECkBVU0VSX0NPTkZJR1VSQVRJT05fRU5UUllfUkVBRF9QRVJNSVNTSU9OX0FETUlOSVNUUkFUT1JTX0FORF9TRUxGEAESPQo5VVNFUl9DT05GSUdVUkFUSU9OX0VOVFJZX1JFQURfUEVSTUlTU0lPTl9QVUJMSUNfQUxMX1VTRVJTEAJCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw");

/**
 * Specifies who can read a particular user configuration entry.
 *
 * @generated from enum time_tracking.enumerations.UserConfigurationEntryReadPermission
 */
export enum UserConfigurationEntryReadPermission {
  /**
   * Only the user the configuration entry belongs to can read it.
   *
   * @generated from enum value: USER_CONFIGURATION_ENTRY_READ_PERMISSION_PRIVATE_SELF_ONLY = 0;
   */
  PRIVATE_SELF_ONLY = 0,

  /**
   * Administrators and the user the configuration entry belongs to can read it.
   *
   * @generated from enum value: USER_CONFIGURATION_ENTRY_READ_PERMISSION_ADMINISTRATORS_AND_SELF = 1;
   */
  ADMINISTRATORS_AND_SELF = 1,

  /**
   * Every user of the tenant can read the configuration entry.
   *
   * @generated from enum value: USER_CONFIGURATION_ENTRY_READ_PERMISSION_PUBLIC_ALL_USERS = 2;
   */
  PUBLIC_ALL_USERS = 2,
}

/**
 * Describes the enum time_tracking.enumerations.UserConfigurationEntryReadPermission.
 */
export const UserConfigurationEntryReadPermissionSchema: GenEnum<UserConfigurationEntryReadPermission> = /*@__PURE__*/
  enumDesc(file_Enumerations_UserConfigurationEntryReadPermission, 0);

